import { render } from "./TertiaryInsurance.vue?vue&type=template&id=4506b248"
import script from "./TertiaryInsurance.vue?vue&type=script&lang=js"
export * from "./TertiaryInsurance.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/orders/billingInfo/forms/TertiaryInsurance.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4506b248"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4506b248', __exports__)) {
    console.log('reload')
    api.reload('4506b248', __exports__)
  }
  
  module.hot.accept("./TertiaryInsurance.vue?vue&type=template&id=4506b248", () => {
    console.log('re-render')
    api.rerender('4506b248', render)
  })

}


export default __exports__